import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import React from "react";
import SortIcon from "../assets/icons/SortIcon";
import colors from "../themes/colors";

export interface TableColumnDefinition {
  title?: string;
  parameter?: number;
  columnAlign?: string;
  twoLevelsColumWidth?: string;
}

export interface SortTableHeadProps {
  columns: TableColumnDefinition[];
  sortBy?: number;
  sortDesc?: boolean;
  onSort: (parameter: number) => void;
  checkboxSelection?: boolean;
  isChecked?: boolean;
  onChangeCheckbox?: () => void;
}

const SortTableHead = ({ columns, sortBy, sortDesc, onSort, checkboxSelection, isChecked, onChangeCheckbox }: SortTableHeadProps) => {
  const getDirection = (parameter?: number): "asc" | "desc" => {
    if (parameter !== sortBy) {
      return "asc";
    }
    return sortDesc ? "desc" : "asc";
  }

  return (
    <TableHead>
      <TableRow>
        {checkboxSelection && (
          <TableCell
            padding="checkbox"
          >
            <Checkbox
              color="primary"
              checked={isChecked}
              onChange={() => onChangeCheckbox ? onChangeCheckbox() : undefined}
            />
          </TableCell>
        )}
        {columns.map((column, index) => (
          <TableCell key={`${index}`} style={{ textAlign: column?.columnAlign as CanvasTextAlign, width: column?.twoLevelsColumWidth }}>
            {column.parameter !== undefined ? (
              <TableSortLabel
                active={column.parameter === sortBy}
                direction={getDirection(column.parameter!)}
                onClick={() => onSort(column.parameter!)}
                IconComponent={SortIcon}
                hideSortIcon={false}
                sx={{
                  "& .MuiTableSortLabel-icon": {
                    opacity: 1,
                    visibility: "visible",
                  },
                  "&:not(.Mui-active) .MuiTableSortLabel-icon": {
                    color: colors.secondary.gray80,
                    "& path": {
                      fill: `${colors.secondary.gray80} !important`,
                      stroke: `${colors.secondary.gray80} !important`,
                      opacity: "1 !important",
                      visibility: "visible !important",
                    }
                  },
                  "&.Mui-active .MuiTableSortLabel-icon": {
                    color: "inherit",
                  }
                }}
              >
                {column.title}
              </TableSortLabel>
            ) : (
              <>
                {column.title}
              </>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SortTableHead;
